/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

import axios from "axios/index"
import { API } from "@/common/constants"

const state = {
  sources: []
}

const getters = {}

const mutations = {
  setSources(state, sources) {
    if (sources && sources.length) {
      console.log(`Set sources: ${sources.length} items`)
      state.sources = sources
    }
  }
}

const actions = {
  getSources({ commit }) {
    return axios
      .get(API.SOURCES)
      .then(response => commit("setSources", response.data))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/util.js